import React, { useRef, useEffect } from 'react';
import './App.css';
import NotFoundPage from './Pages/NotFoundPage';
import Header from './Components/Header';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import { CssBaseline, Paper, Container, Button, Stepper, Step, StepLabel} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Theme from './Components/theme';
import ModalBox from './Components/ModalBox';
import Typography from '@material-ui/core/Typography';
import WelcomePage from './Pages/WelcomePage';
import NewExistingStudentPage from './Pages/NewExistingStudentPage';
import StudentInformationPage from './Pages/StudentInformationPage';
import ChooseApplicationPage from './Pages/ChooseApplicationPage';
import ApplicationPage from './Pages/ApplicationPage';
import SiblingInformationPage from './Pages/SiblingInformationPage';
import TwinTripletInfoPage from './Pages/TwinTripletInfoPage';
import useStyles from './Components/useStyles';
import ConfirmationPage from './Pages/ConfirmationPage';
import DonePage from './Pages/DonePage';
import Subheader from './Components/Subheader';
import { POSTRequest } from './Services/HttpRequestUtil';

function getSteps() {
  return ['Welcome', 'New/Existing Student?', 'Student Applicant Information', 'Twin Information', 'Application Type', 'Sibling Information', 'Application', 'Application Summary'];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return '';
    case 1:
      return '';
    case 2:
      return '';
    case 3:
      return '';
    case 4:
      return '';
    case 5:
      return '';
    case 6:
      return '';
    case 7:
      return '';
    default:
      return 'Unknown step';
  }
}

function App() {
  const classes = useStyles();
  const [validationFail, setValidationFail] = React.useState(false);
  const [newstudent, setNewstudent] = React.useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [studentID, setStudentID] = React.useState(0);
  const [registrationID, setRegistrationID] = React.useState(0);
  const [applicantFirstName, setApplicantFirstName] = React.useState('');
  const [applicantLastName, setApplicantLastName] = React.useState('');
  const [applicantDOB, setApplicantDOB] = React.useState(null);
  const [navigateButtonsHidden, setNavigateButtonsHidden] = React.useState(false);
  const [appliedProgram, setAppliedProgram] = React.useState('');
  const [skipped, setSkipped] = React.useState(new Set());
  const [showNESPage, setShowNESPage] = React.useState(false);
  const [showSIPage, setShowSIPage] = React.useState(false);
  const [showSibIPage, setShowSibIPage] = React.useState(false);
  const [showTTIPage, setShowTTIPage] = React.useState(false);
  const [showCATPage, setShowCATPage] = React.useState(false);
  const [firstChoice, setFirstChoice] = React.useState('');
  const [secondChoice, setSecondChoice] = React.useState('');
  const [thirdChoice, setThirdChoice] = React.useState('');
  const [siblingStudentID, setSiblingStudentID] = React.useState(0);
  const [siblingFirstName, setSiblingFirstName] = React.useState('');
  const [siblingLastName, setSiblingLastName] = React.useState('');
  const [siblingDOB, setSiblingDOB] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [modalTitle, setModalTitle] = React.useState('');
  const [modalMessage, setModalMessage] = React.useState('');
  const [twinID, setTwinID] = React.useState(0);
  const [twinFirstName, setTwinFirstName] = React.useState('');
  const [twinLastName, setTwinLastName] = React.useState('');
  const [twinDOB, setTwinDOB] = React.useState(null);
  const [isInvalidDOB, setIsInvalidDOB] = React.useState(null);
  const [tripletID, setTripletID] = React.useState(0);
  const [tripletFirstName, setTripletFirstName] = React.useState('');
  const [tripletLastName, setTripletLastName] = React.useState('');
  const [tripletDOB, setTripletDOB] = React.useState(null);
  const [email, setEmail] = React.useState('');
  const [phoneNo, setPhoneNo] = React.useState('');
  const [parentFirstName, setParentFirstName] = React.useState('');
  const [parentLastName, setParentLastName] = React.useState('');
  const [firstTimeInSIPage, setFirstTimeInSIPage] = React.useState(true);
  const [firstTimeInSibPage, setFirstTimeInSibPage] = React.useState(true);
  const [firstTimeInTwinPage, setFirstTimeInTwinPage] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const [failedToSubmit, setFailedToSubmit] = React.useState(false);
  const [submitResult, setSubmitResult] = React.useState([]);
  const [isVerified, setIsVerified] = React.useState(''); //https://www.youtube.com/watch?v=3r7YMaT1k6Y Captcha
  //https://stackoverflow.com/questions/20749312/allow-only-requests-from-local-machine-in-webapi-2/20749763 about secure webapi ussage
  const steps = getSteps();
  var validation = true;
  const captchaRef = useRef({});
  const confirmationRef = useRef();
  const [inRange, setIsRanged] = React.useState(null);
  const [fromRegistration, setFromRegistration] = React.useState(false);
  const [schoolYear, setSchoolYear] = React.useState('2026-27');
  const [prevSchoolYear, setPrevSchoolYear] = React.useState('2026-27');
  const [applicationDateRange, setApplicationDateRange] = React.useState('November 1, 2025 - January 16, 2026');
  const [prevApplicationDateRange, setPrevApplicationDateRange] = React.useState('November 1, 2025 - January 16, 2026');  
  const [statusNotificationDate, setStatusNotificationDate] = React.useState('Tuesday, February 10th, 2026');
  const [acknowledgementEmailDate, setAcknowledgementEmailDate] = React.useState('January 30, 2026');
  const [parentReturnEmailDate, setParentReturnEmailDate] = React.useState('Wednesday, February 11th, 2026');
  const [applicationStatusEmailDate, setApplicationStatusEmailDate] = React.useState('4:00 p.m. on Friday, February 13th, 2025');
  const [applicationStartDate, setApplicationStartDate] = React.useState('2025-11-01');
  const [applicationEndDate, setApplicationEndDate] = React.useState('2026-01-17');
  const [pastDeadline, setpastDeadline] = React.useState(false);
  
  useEffect(() => {
    setIsRanged(dateNotInRange())

    var queryString = window.location.href;
    var applicantInfo = parseQuery(queryString);

    if(verifiedQuery(applicantInfo)) {
      setFromRegistration(true);
    }

    if(fromRegistration) {
      setRegistrationID(applicantInfo.registrationID);
      setApplicantFirstName(applicantInfo.FirstName);
      setApplicantLastName(applicantInfo.LastName);
      setApplicantDOB(applicantInfo.DOB)
      setNewstudent(true);
    }
  });
  

  function setResetEverything() {
    setNewstudent(false);
    setActiveStep(0);
    setStudentID(0);
    setRegistrationID(0);
    setApplicantFirstName('');
    setApplicantLastName('');
    setApplicantDOB(null);
    setNavigateButtonsHidden(false);
    setAppliedProgram('');
    setSkipped(new Set());
    SetEffectsOff();
    setResetChoices();
    setSiblingStudentID(0);
    setSiblingLastName('');
    setSiblingFirstName('');
    setSiblingDOB(null);
    setOpenModal(false);
    setModalTitle('');
    setModalMessage('');
    setTwinID(0);
    setTwinFirstName('');
    setTwinLastName('');
    setTwinDOB(null);
    setIsInvalidDOB(null);
    setTripletID(0);
    setTripletFirstName('');
    setTripletLastName('');
    setTripletDOB(null);
    setEmail('');
    setPhoneNo('');
    setFirstTimeInSIPage(true);
    setFirstTimeInSibPage(true);
    setFirstTimeInTwinPage(true);
    setIsVerified('');
    setParentFirstName('');
    setParentLastName('');
    setIsLoading(false);
    confirmationRef.current = null;
    setFailedToSubmit(false);
    setSubmitResult([]);
    setpastDeadline(false);
  }
  function setResetChoices() {
    setFirstChoice('');
    setSecondChoice('');
    setThirdChoice('');
  }

  function setTwinsID(number) {
    setTwinID(number);
    setFirstTimeInTwinPage(false);
  }

  function setTripletsID(number) {
    setTripletID(number);
    setFirstTimeInTwinPage(false);
  }

  function setSiblingPupliNo(number) {
    setSiblingStudentID(number);
    setFirstTimeInSibPage(false);
  }

  function isStepOptional(step) {
    return (step === 3 || step === 5);
  }

  function isNewStudent(result) {
    setNewstudent(result);
    if (result) {
      setRegistrationID(0);
    }
    else {
      setStudentID(0);
    }
    handleNext();
  }

  function setRegId(regID) {
    setRegistrationID(regID);
    setFirstTimeInSIPage(false);
  }

  function setFirChoice(choice) {
    setFirstChoice(choice);
  }

  function setSecChoice(choice) {
    setSecondChoice(choice);
  }

  function setThirChoice(choice) {
    setThirdChoice(choice);
  }

  function setPupulNo(pupil) {
    setStudentID(pupil);
    setFirstTimeInSIPage(false);
  }
  function setAppliedProg(program) {
    if (program !== appliedProgram) {
      InitializeChoices();
    }

    setAppliedProgram(program);
    handleNext();
  }

  function handleBack() {
    let step = activeStep - 1;
    handleSteps(step);
    if (validationFail || !validation) {
      setValidationFail(false);
      validation = true;
      setActiveStep(activeStep-1);    
    }
    else {

      setActiveStep(activeStep-1);

    }
  }

  function handleReset() {
    setResetEverything();
    setActiveStep(0);
  }

  async function handleNext() {
    setNavigateButtonsHidden(false);

    let step = activeStep + 1;

    if(fromRegistration && activeStep == 0) 
    {
      step = 2;
      setActiveStep(2);
    }

    if (step === 8 || step === 1)
      setNavigateButtonsHidden(true);

    await handleSteps(step);

    if (step === 8)
      setNavigateButtonsHidden(false);

    if (!validation) {
      validation = true;
    } else {
      if (fromRegistration && activeStep != 0) {
        setActiveStep(activeStep + 1);
      }
      else if(!fromRegistration) {
        setActiveStep(activeStep + 1);
      }

    // if (!validation)
    //   validation = true;
    // if (fromRegistration && activeStep != 0) {
    //   setActiveStep(activeStep + 1);
    // }
    // else if(!fromRegistration) {
    //   setActiveStep(activeStep + 1);
    // }
    }
  }

  async function SubmitForm(token, firstname, lastname, contactemail, phonenumber) {
    let msg = '';
    let result = 0;

    let today = new Date();
    let endDate = new Date(applicationEndDate);
    
    let endDiff = (endDate.getTime() - today.getTime()) / (1000 * 3600 * 24)

    if(endDiff < 0) {
      msg = msg + 'The submission deadline has already passed;';
      setpastDeadline(true);
    }

    if (token === '' || token === null || firstname === '' || lastname === '' || contactemail === '' || phonenumber === '') {
      if (token === '' || token === null) {
        //msg = msg + 'Please verifiy that you are a human; ';
      }
      else if (firstname === '') {
        msg = msg + 'Please enter your first name; ';
      }
      else if (lastname === '') {
        msg = msg + 'Please enter your last name; ';
      }
      else if (contactemail === '') {
        msg = msg + 'Please enter your Email; ';
      }
      else if (phonenumber === '') {
        msg = msg + 'Please enter your phone number; ';
      }
    }
    if (msg === '') {
      //for Dev
      setIsLoading(true);
      result = await submitData(token, firstname, lastname, contactemail, phonenumber);

      //result = 200;
      if (result === 401) {
        msg = msg + 'Please verify Captcha; ' + result;
      }
      else if (result !== 200) {
        msg = msg + 'Failed to save data! Please contact SD38; ';
      }
      //proceed submitting, captcha passed
    }
    if (msg !== '') {
      //failed to prove human
      setModalMessage(msg);
      setModalTitle('Error');
      setOpenModal(true);
    }

    return msg;
  }

  async function submitData(token, firstname, lastname, contactemail, phonenumber) {
    const body = JSON.stringify({
      registrationID: registrationID,
      studentID: studentID,
      applicantDOB: applicantDOB,
      applicantFirstName: applicantFirstName,
      applicantLastName: applicantLastName,
      applyingProgram: appliedProgram,
      firstChoice: firstChoice,
      secondChoice: secondChoice,
      thirdChoice: thirdChoice,
      siblingStudentID: siblingStudentID,
      siblingDOB: siblingDOB,
      siblingFirstName: siblingFirstName,
      siblingLastName: siblingLastName,
      twinRegID: registrationID === 0 || registrationID === null ? 0 : twinID,
      twinStudentID: studentID === 0 || studentID === null ? 0 : twinID,
      twinFirstName: twinFirstName,
      twinLastName: twinLastName,
      twinDOB: twinDOB,
      email: contactemail,
      parentFirstName: firstname,
      parentLastName: lastname,
      phoneNo: phonenumber,
      callingEntity: 0,
      lastModified: contactemail
    });

    function automatePublish() {
      if(window.location.hostname === "mis-dev2019-ap.rsd38.ca" || window.location.hostname === "mis-stg2019-ap.rsd38.ca" || window.location.hostname === "mis-prd2019-ap.rsd38.ca") {
        const url = '/DPOAPI/api/ApplicationSubmisson/';
        return url;
      } else if(window.location.hostname === "localhost") {
        const url = '/api/ApplicationSubmisson/';
        return url;
      } else {
        const url = '/api/DPOApplicationSubmission/';
        return url;
      }
    }
    return await POSTRequest(body, automatePublish(), token, setSubmitResult);

  }

  function SetEffectsOff() {
    setShowNESPage(false);
    setShowSIPage(false);
    setShowSibIPage(false);
    setShowTTIPage(false);
    setShowCATPage(false)
  }

  function InitializeChoices() {
    setFirstChoice('');
    setSecondChoice('');
    setThirdChoice('');
  }
  function handleCloseModal() {
    setOpenModal(false);
  }
  function setParentInfo() {
    if (confirmationRef.current !== undefined && confirmationRef.current !== null && confirmationRef.current != {}) {
      setParentFirstName(confirmationRef.current.parentFirstName);
      setParentLastName(confirmationRef.current.parentLastName);
      setEmail(confirmationRef.current.email);
      setPhoneNo(confirmationRef.current.phoneNo);
      return true;
    }

    return false;
  }

  function clearIDs() {
    setStudentID(null);
    setRegistrationID(null);
  }

  function validateTwinAge(applicantDOB, twinDOB) {
    const applicantAge = new Date(applicantDOB);
    const twinAge = new Date(twinDOB);
    const ageDifference = (Math.abs(applicantAge.getTime() - twinAge.getTime())) / (1000 * 3600 * 24);
  
    if(ageDifference <= 1 || twinDOB == null) {
      return false;
    } else {
      return true;
    } 
  }  
  
  function validateYear(dob) {
    const currentYear = new Date().getFullYear();
    const dobYear = new Date(dob).getFullYear();
    const difference = currentYear - dobYear;

    return (difference);
  }

  function dateNotInRange() {
    let today = new Date();
    // let today = new Date('2025-11-01');
    let startDate = new Date(applicationStartDate);
    let endDate = new Date(applicationEndDate)

    let startDiff = (startDate.getTime() - today.getTime()) / (1000 * 3600 * 24)
    let endDiff = (endDate.getTime() - today.getTime()) / (1000 * 3600 * 24)

    if(startDiff > 0 || endDiff < 0) {
      return true
    } else {
      return false
    }
  }

  function parseQuery(queryString) {
    var query = {};
    var shortenedQueryString = queryString.substring(queryString.lastIndexOf("?"));
    var pairs = (shortenedQueryString[0] === '?' ? shortenedQueryString.substr(1) : shortenedQueryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }

  function verifiedQuery(array) {
    let count = 0;
    for (let k in array) 
      if (array.hasOwnProperty(k)) 
        count++;

    if(count == 4) 
      return true
    else 
      return false
  }

  const regexp = new RegExp(`^[0-9]*$`);

  async function handleSteps(step) {
    const emailregexp = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const regexpName = /^[-A-Za-z ]+$/;
    var existingStudent = studentID === null || studentID === 0 ? false : true;
    let msg = '';

    switch (step) {
      case 0:
        setNavigateButtonsHidden(false);
        break;
      case 1:
        setNavigateButtonsHidden(true);
        setShowNESPage(true);
        setFirstTimeInSIPage(true);
        clearIDs();
        break;
      case 2:
        setNavigateButtonsHidden(false);
        setShowSIPage(true);
        break;
      case 3: //Twin Information Page
        setFirstTimeInSIPage(true);
        setShowCATPage(true);
        setNavigateButtonsHidden(false);
        existingStudent = studentID === null || studentID === 0 ? false : true;
        let ageDifference = validateYear(applicantDOB);
        if (((studentID == null || studentID == 0) && (registrationID == null || registrationID == 0))
          || (applicantDOB === null) || (applicantFirstName === '') || (applicantLastName === '') || !regexpName.test(applicantFirstName) || !regexpName.test(applicantLastName) || ageDifference < 4) {
          setValidationFail(true);
          validation = false;
          let msg = ((studentID === null || studentID == 0) && (registrationID === null || registrationID == 0) ? ('Student\'s ' + (newstudent ? 'Registration ' : 'Pupil ' ) + 'number is empty \n') : '')
            + (applicantDOB === null ? 'Student\'s DOB is empty \n' : '') + (applicantFirstName === '' ? 'Student’s first name is empty \n' : '') + (applicantLastName === '' ? 'Student’s last name is empty \n' : '') 
            + (!regexpName.test(applicantFirstName) && !(applicantFirstName === '') ? 'Student\'s first name must be in English characters \n' : '') + ((ageDifference < 4) ? 'Student is too young to apply \n' : '') + (!regexpName.test(applicantLastName) && !(applicantLastName === '') ? 'Student\'s last name must be in English characters \n' : '');
          let splitMsg = msg.split('\n').map(i => {
            return <p>{i}</p>
          });
          setModalMessage(splitMsg);
          setModalTitle('Error');
          setOpenModal(true);
          setNavigateButtonsHidden(false);
          setShowSIPage(true);
        }
        else if (((existingStudent && !regexp.test(studentID)) || (!existingStudent && !regexp.test(registrationID)))) {
          setValidationFail(true);
          validation = false;
          setModalMessage('Student\'s ID must contain only numbers');
          setModalTitle('Error');
          setOpenModal(true);
          clearIDs();
          setNavigateButtonsHidden(false);
          setShowSIPage(true);
        }
        else
          setShowTTIPage(true);
        break;
        case 4: //Application Type Page
          setFirstTimeInSIPage(true);
          msg = '';
  
          let twinMsg = validateSiblingTwins(twinID, twinFirstName, twinLastName, twinDOB);
          if (twinMsg !== '') {
            msg = msg + twinMsg + " ";
          }
  
          if (msg !== '' || validateTwinAge(applicantDOB, twinDOB) || isInvalidDOB) {
            msg = msg + (validateTwinAge(applicantDOB, twinDOB) ? 'Twin\'s birthdate does not match student applicant\'s birthdate \n' : '')
            + (isInvalidDOB ? 'Entering partial DOB \n' : '');
            let splitMsg = msg.split('\n').map(i => {
              return <p>{i}</p>
            });
            setModalMessage(splitMsg);
            setIsInvalidDOB(null);
            setModalTitle('Error');
            setOpenModal(true);
            validation = false;

          }
          else {

            setNavigateButtonsHidden(true);  
          }
          break;
      case 5: //Sibling Page
        setNavigateButtonsHidden(false);
        setFirstTimeInTwinPage(true);
        setShowSibIPage(true);
        break;
      case 6: //Application page
        msg = validateSiblingTwins(siblingStudentID, siblingFirstName, siblingLastName, siblingDOB);
        let siblingAge = validateYear(siblingDOB);
        if (msg !== '' || isInvalidDOB || siblingAge < 4) {
          msg = msg + (isInvalidDOB ? ' Entering partial DOB' : '') + (siblingAge < 4 ? ' The Sibling is too young' : '' );
          let splitMsg = msg.split('\n').map(i => {
            return <p>{i}</p>
          });
          setModalMessage(splitMsg);
          setIsInvalidDOB(null);
          setModalTitle('Error');
          setOpenModal(true);
          validation = false;
          setShowSibIPage(true);

        }
        else {
          setFirstTimeInSibPage(true);
        }
        break;
        case 7: //Summary Page
        setShowSibIPage(true);
        if (firstChoice === '' || firstChoice === null) {
          setValidationFail(true);
          validation = false;
          setModalMessage('First Choice school is required');
          setModalTitle('Error');
          setOpenModal(true);

        }
        else if ((secondChoice === '' || secondChoice === null) && thirdChoice !== '' && thirdChoice !== null) {
          setValidationFail(true);
          validation = false;
          setModalMessage('You are missing a second choice school');
          setModalTitle('Error');
          setOpenModal(true);
        }
        else if (firstChoice === secondChoice || (secondChoice !== '' && secondChoice === thirdChoice) || firstChoice === thirdChoice) {
          setValidationFail(true);
          validation = false;
          setModalMessage('You can not select a school more than once');
          setModalTitle('Error');
          setOpenModal(true);
        }
        else {
          setParentInfo();
        }
        break;
      case 8:
        let populated = setParentInfo();
        let token = '';
        let firstname = '';
        let lastname = '';
        let contactemail = '';
        let phonenumber = '';
        if (populated) {
          token = captchaRef.current.getValue();
          firstname = confirmationRef.current.parentFirstName;
          lastname = confirmationRef.current.parentLastName;
          contactemail = confirmationRef.current.email;
          phonenumber = confirmationRef.current.phoneNo;
        }
        
        if (firstname === '' || lastname === '' || phonenumber === '' || contactemail === '' || contactemail === null || (contactemail !== '' && !emailregexp.test(contactemail)) || token === '' || token === null)
        {
          setNavigateButtonsHidden(false);
          setValidationFail(true);
          validation = false;
          let msg = ((phonenumber === '') ? 'Empty Phone Number \n' : '')
            + (contactemail === '' || !emailregexp.test(contactemail) ? 'Enter a valid email address \n' : '') + (firstname === '' ? 'Empty First Name \n' : '') + (lastname === '' ? 'Empty Last Name \n' : '') + (token === '' ? 'Must complete Captcha \n' : '');
            let splitMsg = msg.split('\n').map(i => {
              return <p>{i}</p>
            });
            openModalPopUp(splitMsg);
        }
        else {
          setFailedToSubmit(false);
          let msg = await SubmitForm(token, firstname, lastname, contactemail, phonenumber);      
          if(msg !== null && msg !== '') {
            openModalPopUp(msg);
            setFailedToSubmit(true);
          }
        }
        break;
      default:
    }
  }

  function openModalPopUp(msg) {
    setModalMessage(msg);
    setModalTitle('Error');
    setOpenModal(true);
  }

  function validateSiblingTwins(id, firstname, lastname, dob) {
    const regexpName = /^[-A-Za-z ]+$/;
    let errorMsg = '';
    if (id !== null && id !== '' && id !== 0) {
      if (firstname === null || firstname === '') {
        errorMsg = errorMsg + ' First name is empty\n';
      }
      if (lastname === null || lastname === '') {
        errorMsg = errorMsg + ' Last name is empty\n';
      }
      if(!regexpName.test(firstname) && !(firstname === null || firstname === '')) {
        errorMsg = errorMsg + ' First name with english letters only\n';
      }
      if(!regexpName.test(lastname) && !(lastname === null || lastname === '')) {
        errorMsg = errorMsg + ' Last name with english letters only\n';
      }
      if ((dob === null || dob === '') && !isInvalidDOB) {
        errorMsg = errorMsg + ' DOB is empty\n';
      }
      if (!regexp.test(id))
        errorMsg = errorMsg + ' ID must contain only numbers\n';
    }
    else if ((firstname !== '') || (lastname !== '') || (dob !== null)) {
      if (firstname === null || firstname === '') {
        errorMsg = errorMsg + ' First name is empty\n';
      }
      if(!regexpName.test(firstname) && !(firstname === null || firstname === '')) {
        errorMsg = errorMsg + ' First name with english letters only\n';
      }
      if(!regexpName.test(lastname) && !(lastname === null || lastname === '')) {
        errorMsg = errorMsg + ' Last name with english letters only\n';
      }
      if (lastname === null || lastname === '') {
        errorMsg = errorMsg + ' Last name is empty\n';
      }
      if ((dob === null || dob === '') && !isInvalidDOB) {
        errorMsg = errorMsg + ' DOB is empty\n';
      }
    }
    return errorMsg;
  }

  function handleCaptchaChange(newValue) {
    setIsVerified(newValue);
  }

  function DisplayPage(step) {
    switch (step.index) {
      case 0:
        return <WelcomePage inProp={true} inRange={inRange} prevSchoolYear={prevSchoolYear} schoolYear={schoolYear} prevApplicationDateRange={prevApplicationDateRange} applicationDateRange={applicationDateRange} statusNotificationDate={statusNotificationDate}/>;
      case 1:
        return <NewExistingStudentPage isNewStudent={isNewStudent} showNESPage={showNESPage} schoolYear={schoolYear} prevSchoolYear={prevSchoolYear}/>;
      case 2:
        return <StudentInformationPage isNewstudent={newstudent} setRegId={setRegId} setPupulNo={setPupulNo} studentID={studentID} registrationID={registrationID} showSIPage={showSIPage} firstTimeInSIPage={firstTimeInSIPage}
          setApplicantFirstName={setApplicantFirstName} setApplicantLastName={setApplicantLastName} setApplicantDOB={setApplicantDOB} applicantDOB={applicantDOB}
          applicantFirstName={applicantFirstName} applicantLastName={applicantLastName} />;
      case 3:
        let twinLable = " pupil number";
        if (studentID === 0 || studentID === '' || studentID === null) {
          twinLable = " registration number";
        }
        return <TwinTripletInfoPage showTTIPage={showTTIPage} twinLable={twinLable} setTwinsID={setTwinsID} twinID={twinID} firstTimeInTwinPage={firstTimeInTwinPage}
          setTwinFirstName={setTwinFirstName} setTwinLastName={setTwinLastName} setTwinDOB={setTwinDOB} twinFirstName={twinFirstName} twinLastName={twinLastName} twinDOB={twinDOB} setIsInvalidDOB={setIsInvalidDOB}
        />;
      case 4:
        return <ChooseApplicationPage setAppliedProgram={setAppliedProg} showCATPage={showCATPage} />;
      case 5:
        return <SiblingInformationPage setSiblingPupliNo={setSiblingPupliNo} siblingStudentID={siblingStudentID} showSibIPage={showSibIPage} firstTimeInSibPage={firstTimeInSibPage}
          setSiblingFirstName={setSiblingFirstName} setSiblingLastName={setSiblingLastName} setSiblingDOB={setSiblingDOB} siblingFirstName={siblingFirstName}
          siblingLastName={siblingLastName} siblingDOB={siblingDOB} setIsInvalidDOB={setIsInvalidDOB} appliedProgram={appliedProgram}/>;
      case 6:
        return <ApplicationPage program={appliedProgram} setFirChoice={setFirChoice} setSecondChoice={setSecChoice} setThirdChoice={setThirChoice} firstChoice={firstChoice} secondChoice={secondChoice} thirdChoice={thirdChoice}
          siblingDOB={siblingDOB}/>;
      case 7:
        return <ConfirmationPage studentID={studentID} registrationID={registrationID} appliedProgram={appliedProgram} firstChoice={firstChoice} secondChoice={secondChoice} thirdChoice={thirdChoice}
          applicantDOB={applicantDOB} applicantFirstName={applicantFirstName} applicantLastName={applicantLastName} siblingDOB={siblingDOB} siblingFirstName={siblingFirstName} siblingLastName={siblingLastName}
          siblingStudentID={siblingStudentID} twinID={twinID} twinDOB={twinDOB} twinFirstName={twinFirstName} twinLastName={twinLastName} handleCaptchaChange={handleCaptchaChange} confirmationRef={confirmationRef}
          tripletID={tripletID} tripletDOB={tripletDOB} tripletFirstName={tripletFirstName} tripletLastName={tripletLastName} ParparentLastName={parentLastName} captchaRef={captchaRef}
          Paremail={email} ParphoneNo={phoneNo} ParparentFirstName={parentFirstName} />;
      case 8:
        return <DonePage inProp={true} failedToSubmit={failedToSubmit} submitResult={submitResult.Id} applicationType={submitResult.Message} pastDeadline={pastDeadline}
        acknowledgementEmailDate={acknowledgementEmailDate} parentReturnEmailDate={parentReturnEmailDate} applicationStatusEmailDate={applicationStatusEmailDate} statusNotificationDate={statusNotificationDate}/>;
      default:
        return <NotFoundPage />;
    }
  }
  return (
    <>
      <Header />
      <form>
        <CssBaseline />
        <div className="App">
          <Subheader />
          <Navbar />
          <Subheader />
          <Container maxWidth="md" className={classes.container}>
            <MuiThemeProvider theme={Theme}>
              <Stepper activeStep={activeStep} style={{display: inRange? "none" : "null"}} className={classes.stepper} >
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};
                  if (isStepOptional(index)) {
                    labelProps.optional = <Typography variant="caption">Optional</Typography>;
                  }
                  /*       if (isStepSkipped(index)) {
                          stepProps.completed = false;
                        } */
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              <div className={classes.bottompart}>
              {activeStep === steps.length ? (
                  <div>
                    <Button onClick={handleReset} className={classes.backbutton} disabled={navigateButtonsHidden}>
                      Restart
                </Button>
                  </div>
                ) : (
                    <div>
                      <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
                      <div style={{display: inRange? "none" : "null"}}>
                      <ArrowBackIcon className={classes.arrow} color={inRange ? "disabled" : isLoading ? "disabled" : activeStep === 0 ? "disabled" : "primary"} disabled={isLoading || navigateButtonsHidden}
                      onClick={isLoading ? null : activeStep === 0 ? null : handleBack}></ArrowBackIcon>
                        <Button color={"primary"} onClick={handleBack} 
                        className={classes.backbutton} disabled={inRange || isLoading || activeStep === 0}>
                          Back
                        </Button>
                        <Button
                          variant="contained"
                          color={"primary"}
                          onClick={handleNext}
                          className={classes.nextbutton}
                          disabled={inRange || isLoading || navigateButtonsHidden}
                        >
                            {isLoading ? 'please wait...' : activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                        </Button>
                        <ArrowForwardIcon  
                          variant="contained"
                          color={inRange ? "disabled" : isLoading ? "disabled" : navigateButtonsHidden ? "disabled" : "primary"}
                          onClick={inRange ? null : isLoading ? null : navigateButtonsHidden ? null : handleNext}
                          className={classes.arrow}
                          > 
                            {isLoading ? 'please wait...' : activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                  </ArrowForwardIcon>
                        <ModalBox message={modalMessage} title={modalTitle} open={openModal} close={handleCloseModal} />
                      </div>
                    </div>
                  )}
              </div>
              <Paper className={classes.body}>
                <DisplayPage index={activeStep} key={Math.random()} />
              </Paper>
              <div>&nbsp;</div>
              <div className={classes.bottompart}>
                {activeStep === steps.length ? (
                  <div>
                    <Typography className={classes.instructions}>
                      All steps completed - you are finished
                </Typography>
                    <Button onClick={handleReset} className={classes.backbutton} disabled={navigateButtonsHidden}>
                      Restart
                </Button>
                  </div>
                ) : (
                    <div>
                      <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
                      <div style={{display: inRange? "none" : "null"}}>
                        <ArrowBackIcon className={classes.arrow} color={inRange ? "disabled" : isLoading ? "disabled" : activeStep === 0 ? "disabled" : "primary"} disabled={isLoading || navigateButtonsHidden} 
                        onClick={inRange ? null : isLoading ? null : activeStep === 0 ? null : handleBack}></ArrowBackIcon>
                        <Button color={"primary"} onClick={handleBack} 
                        disabled={inRange || isLoading || activeStep === 0}>
                          Back
                        </Button>
                        <Button
                          variant="contained"
                          color={"primary"}
                          onClick={handleNext}
                          className={classes.nextbutton}
                          disabled={inRange || isLoading || navigateButtonsHidden}
                        >
                            {isLoading ? 'please wait...' : activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                        </Button>
                        <ArrowForwardIcon  
                          variant="contained"
                          color={inRange ? "disabled" : isLoading ? "disabled" : navigateButtonsHidden ? "disabled" : "primary"}
                          onClick={inRange ? null : isLoading ? null : navigateButtonsHidden ? null : handleNext}
                          className={classes.arrow}
                          > 
                            {isLoading ? 'please wait...' : activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                  </ArrowForwardIcon>
                        <ModalBox message={modalMessage} title={modalTitle} open={openModal} close={handleCloseModal} />
                      </div>
                    </div>
                  )}
              </div>
              <br /><br />
              <Footer />
            </MuiThemeProvider>
          </Container>
        </div>
      </form>
    </>
  );
}

export default App;
